// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA-1gg_hUoeSI13oyx7Vo29kOsRB4NHX_U",
  authDomain: "pou-remake.firebaseapp.com",
  projectId: "pou-remake",
  storageBucket: "pou-remake.firebasestorage.app",
  messagingSenderId: "949736267543",
  appId: "1:949736267543:web:82c701124628a13f246152",
  measurementId: "G-WSSKRTF9KB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const Db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
